// CarePlanEngagementChart.jsx
import React, { useEffect, useRef } from "react";
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";

const CarePlanEngagementChart = ({ labels = [], values = [] }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    // Register the necessary Chart.js components
    Chart.register(
      LineController,
      LineElement,
      PointElement,
      LinearScale,
      Title,
      CategoryScale,
      Tooltip,
      Legend
    );

    const ctx = chartRef.current.getContext("2d");
    const data = {
      labels,
      datasets: [
        {
          label: "Care Plan Engagement",
          data: values,
          fill: false,
          borderColor: "#2DC4CF",
          tension: 0.2,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        title: { display: false },
      },
      scales: {
        x: {
          type: "category",
          grid: { display: false },
        },
        y: {
          beginAtZero: true,
          max: 100,
          grid: {
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: false,
          },
          ticks: {
            callback: (value) =>
              [0, 10, 20, 40, 60, 80, 100].includes(value) ? value : null,
          },
        },
      },
    };

    // Cleanup old chart instance
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    // Create new chart
    chartInstanceRef.current = new Chart(ctx, {
      type: "line",
      data,
      options,
    });

    // Destroy on unmount
    return () => {
      chartInstanceRef.current.destroy();
    };
  }, [labels, values]);

  return (
    <div className="chart-container">
      <canvas ref={chartRef} />
    </div>
  );
};

export default CarePlanEngagementChart;
